import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import React from 'react';
import { compose, variant } from 'styled-system';

import { MedicationFollowupMessageOnAllPatientListFragment } from '~/graphql/generated/graphql';

type Props = {
  latestSentFollowupMessage: MedicationFollowupMessageOnAllPatientListFragment | null;
  latestSentFollowupAutoReplyMessage: MedicationFollowupMessageOnAllPatientListFragment | null;
};

const ListItem = styled('li', { shouldForwardProp })<{
  color: 'pink' | 'gray' | 'white';
  fontWeight?: 'bold';
}>(
  ({ theme }) =>
    css({
      display: 'flex',
      alignItems: 'center',
      '&::before': {
        content: '"●"',
        fontSize: '16px',
        marginRight: theme.space.s,
      },
    }),
  ({ theme }) =>
    compose(
      variant({
        prop: 'color',
        variants: {
          pink: css({
            '&::before': {
              color: theme.colors.colorPallete.pink,
            },
          }),
          gray: css({
            '&::before': {
              color: theme.colors.colorPallete.grey05,
            },
          }),
          white: css({
            '&::before': {
              color: theme.colors.colorPallete.white,
            },
          }),
        },
      }),
      variant({
        prop: 'fontWeight',
        variants: {
          bold: css({
            fontWeight: 'bold',
          }),
        },
      }),
    ),
);

export const QuestionnaireSheetColumn = (props: Props) => {
  const { latestSentFollowupMessage, latestSentFollowupAutoReplyMessage } = props;

  if (
    !latestSentFollowupMessage ||
    !latestSentFollowupMessage.medicationFollowupQuestionnaireRevision
  ) {
    return <ListItem color="white">-</ListItem>;
  }

  if (!latestSentFollowupMessage.medicationFollowupQuestionnaireSheet) {
    return <ListItem color="gray">回答待ち</ListItem>;
  }

  if (
    latestSentFollowupMessage.isRead &&
    latestSentFollowupAutoReplyMessage &&
    !latestSentFollowupAutoReplyMessage.medicationFollowupQuestionnaireSheet
  ) {
    return <ListItem color="gray">回答あり</ListItem>;
  }

  if (latestSentFollowupAutoReplyMessage && latestSentFollowupAutoReplyMessage.isRead === false) {
    return (
      <ListItem color="pink" fontWeight="bold">
        回答あり
      </ListItem>
    );
  }

  if (latestSentFollowupMessage.isRead) {
    return <ListItem color="gray">回答あり</ListItem>;
  }

  if (
    latestSentFollowupAutoReplyMessage &&
    (latestSentFollowupAutoReplyMessage.isRead === false ||
      latestSentFollowupMessage.isRead === false) &&
    latestSentFollowupAutoReplyMessage.sendAt > latestSentFollowupMessage.sendAt
  ) {
    return <ListItem color="gray">回答あり</ListItem>;
  }

  return (
    <ListItem color="pink" fontWeight="bold">
      回答あり
    </ListItem>
  );
};
